import BaseService from '@/api/services/BaseService';

const API_RESOURCE = {
  BASE: 'sms/contact',
  ALL: 'sms/contacts/list',
  CURRENT_USER: 'sms/contact/user',
  ENTERPRISE: 'sms/contact/account',
  AVATARS: 'sms/photos/azure'
};

export default class ContactService extends BaseService {
  static upsertUserContact(contact) {
    const URI = `${API_RESOURCE.BASE}`;
    return this.postRequest(URI, contact);
  }

  static deleteUserContact(contactId) {
    const URI = `${API_RESOURCE.BASE}/${contactId}`;
    return this.deleteRequest(URI);
  }

  static getAllContacts() {
    const URI = `${API_RESOURCE.ALL}/${this.encodedUserId}`;
    return this.getRequest(URI);
  }

  static getUserContacts() {
    const URI = `${API_RESOURCE.CURRENT_USER}/${this.encodedUserId}`;
    return this.getRequest(URI);
  }

  static getEnterpriseContacts() {
    const URI = `${API_RESOURCE.ENTERPRISE}/${this.encodedEnterpriseId}`;
    return this.getRequest(URI);
  }

  static getContactAvatars(contactsList, size = 48) {
    const URI = `${API_RESOURCE.AVATARS}/${this.encodedUserId}/${size}`;
    return this.postRequest(URI, contactsList);
  }
}
